/* BRUSH homepage sections — shared behaviour (reveals, carousels, vendor filters, reels autoplay). Added via Claude. */
(function () {
  if (window.__brushHome) { return; }
  window.__brushHome = true;

  function reveal(root) {
    var els = [].slice.call(root.querySelectorAll('.brush-home .rv:not(.in)'));
    if (!els.length) return;
    if (window.Shopify && Shopify.designMode) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      els.forEach(function (el) { io.observe(el); });
    } else { els.forEach(function (el) { el.classList.add('in'); }); }
    setTimeout(function () { els.forEach(function (el) { el.classList.add('in'); }); }, 2500);
    document.addEventListener('visibilitychange', function () { els.forEach(function (el) { el.classList.add('in'); }); }, { once: true });
  }

  function carousels(root) {
    root.querySelectorAll('.brush-home [data-arrows]').forEach(function (ar) {
      if (ar.__bh) return; ar.__bh = true;
      var sec = ar.closest('.brush-home');
      var track = sec.querySelector('[data-track="' + ar.getAttribute('data-arrows') + '"]');
      if (!track) return;
      var prev = ar.children[0], next = ar.children[1];
      function step() { var c = track.querySelector('.pc:not([hidden])'); return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 14) : 320; }
      function upd() { prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd(); setTimeout(upd, 800);
      track.__upd = upd;
    });
    root.querySelectorAll('.brush-home [data-filters]').forEach(function (f) {
      if (f.__bh) return; f.__bh = true;
      var sec = f.closest('.brush-home');
      var track = sec.querySelector('[data-track="' + f.getAttribute('data-filters') + '"]');
      if (!track) return;
      f.addEventListener('click', function (e) {
        var b = e.target.closest('.chip'); if (!b) return;
        f.querySelectorAll('.chip').forEach(function (c) { c.classList.toggle('on', c === b); });
        var v = b.getAttribute('data-v') || '';
        track.querySelectorAll('.pc').forEach(function (c) { c.hidden = !!v && c.getAttribute('data-vendor') !== v; });
        track.scrollTo({ left: 0, behavior: 'smooth' });
        if (track.__upd) setTimeout(track.__upd, 400);
      });
    });
  }

  function reels(root) {
    var vids = [].slice.call(root.querySelectorAll('.brush-home .reel video[data-autoplay]'));
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { if (!v.__bh) { v.__bh = true; io.observe(v); } });
  }

  function init(root) { root = root || document; reveal(root); carousels(root); reels(root); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
